import { render, staticRenderFns } from "./display-json.vue?vue&type=template&id=75834dc3&"
import script from "./display-json.vue?vue&type=script&lang=ts&"
export * from "./display-json.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports